import { calcularLedgerComisionEdificio } from "./calcularLedgerComisionEdificio";
import { client } from "./supabase";

const ESTADOS_OPERATIVOS = ["OPERATIVO", "INSTALACIÓN", "REACTIVACIÓN"];

// Comisiones de edificios se liquidan trimestralmente: enero, abril, julio, octubre.
// Día 15 como referencia. Si hoy ya pasó día 15 del mes en curso de pago, devuelve el siguiente.
const proximaFechaPago = () => {
  const hoy = new Date();
  const mesesPago = [1, 4, 7, 10];
  for (let i = 0; i < 14; i++) {
    const candidato = new Date(hoy.getFullYear(), hoy.getMonth() + i, 15);
    if (mesesPago.includes(candidato.getMonth() + 1) && candidato >= hoy) {
      return candidato.toISOString().split("T")[0];
    }
  }
  return `${hoy.getFullYear() + 1}-01-15`;
};

export const getEdificiosSaldoPendiente = async ({ pais, fechaInicio, monedaLocal }) => {
  const { data: edificios } = await client
    .from("edificios")
    .select(
      "id, edificio, pantallas, totems, espera, cowork, " +
        "comision_1_fechainicio, comision_1_fechafin, comision_1_porcentaje, " +
        "comision_2_fechainicio, comision_2_fechafin, comision_2_porcentaje, " +
        "comision_3_fechainicio, comision_3_fechafin, comision_3_porcentaje, " +
        "comision_fija_monto, comision_fija_inicio, comision_fija_fin, comision_fija_moneda"
    )
    .eq("pais", pais)
    .in("estado", ESTADOS_OPERATIVOS);

  const edificioIds = (edificios || []).map((e) => e.id);
  const edificiosMap = Object.fromEntries((edificios || []).map((e) => [e.id, e]));

  if (edificioIds.length === 0) return [];

  const calcularCierreUltimoQ = () => {
    const hoy = new Date();
    const mes = hoy.getMonth() + 1;
    const año = hoy.getFullYear();
    if (mes <= 3) return `${año - 1}-12-31`;
    if (mes <= 6) return `${año}-03-31`;
    if (mes <= 9) return `${año}-06-30`;
    return `${año}-09-30`;
  };
  const fechaFin = calcularCierreUltimoQ();

  const ledgerEntries = await calcularLedgerComisionEdificio({
    edificioIds,
    edificiosMap,
    fechaInicio,
    fechaFin,
    pais,
  });

  const debitosPorEdificio = {};
  const nombrePorEdificio = {};
  const monedaPorEdificio = {};
  for (const entry of ledgerEntries) {
    const id = entry.edificioId;
    debitosPorEdificio[id] = (debitosPorEdificio[id] || 0) + (entry.debito || 0);
    nombrePorEdificio[id] = entry.edificioNombre;
    monedaPorEdificio[id] = entry.moneda;
  }

  // Filtro estricto: solo pagos con categoria_pago='comision_edificio' cuentan como crédito.
  // Otros movimientos con entidad_tipo='edificio' (ej. CapEx imputado) no se restan acá.
  const { data: pagos } = await client
    .from("movimientos_caja")
    .select("entidad_id, monto")
    .eq("pais", pais)
    .eq("entidad_tipo", "edificio")
    .eq("tipo", "pago")
    .eq("categoria_pago", "comision_edificio")
    .neq("estado", "anulado")
    .gte("fecha", fechaInicio);

  const creditosPorEdificio = {};
  for (const p of pagos || []) {
    const id = p.entidad_id;
    creditosPorEdificio[id] = (creditosPorEdificio[id] || 0) + Number(p.monto || 0);
  }

  const proxFecha = proximaFechaPago();

  const resultado = [];
  for (const id of edificioIds) {
    const debito = debitosPorEdificio[id] || 0;
    if (debito === 0) continue;
    const credito = creditosPorEdificio[id] || 0;
    const saldo = debito - credito;
    if (saldo <= 0) continue;
    resultado.push({
      edificioId: Number(id),
      edificioNombre: nombrePorEdificio[id] || edificiosMap[id]?.edificio || `Edificio #${id}`,
      debitoTotal: debito,
      creditoTotal: credito,
      saldoPendiente: saldo,
      moneda: monedaPorEdificio[id] || monedaLocal,
      proximaFecha: proxFecha,
    });
  }

  return resultado.sort((a, b) => b.saldoPendiente - a.saldoPendiente);
};
